<template>
  <div class="imcraft-hud" aria-label="ImCraft map interface">
    <header class="imcraft-topbar">
      <a class="imcraft-brand" href="https://im-craft.ru" target="_blank" rel="noopener noreferrer" title="Открыть сайт ImCraft">
        <span class="imcraft-brand__mark">IM</span>
        <span class="imcraft-brand__copy">
          <span class="imcraft-brand__name">ImCraft</span>
          <span class="imcraft-brand__subtitle">живая карта сервера</span>
        </span>
      </a>

      <div class="imcraft-topbar__center">
        <div class="imcraft-pill imcraft-pill--online">
          <span class="imcraft-pulse" aria-hidden="true"></span>
          <span>mc.im-craft.ru</span>
        </div>
        <div class="imcraft-pill">
          <span>{{ currentMapName }}</span>
        </div>
      </div>

      <div class="imcraft-actions">
        <button class="imcraft-action imcraft-action--ghost" type="button" @click="copyServerIp">
          {{ copied ? 'IP скопирован' : 'Скопировать IP' }}
        </button>
        <button class="imcraft-action imcraft-action--primary" type="button" @click="openLoginStub">
          Войти
        </button>
      </div>
    </header>

    <aside v-if="!heroHidden" class="imcraft-hero-card">
      <button class="imcraft-hero-card__close" type="button" @click="setHeroHidden(true)" aria-label="Скрыть окно">×</button>
      <h1>Открытая 3D карта сервера ImCraft</h1>

      <div class="imcraft-hero-card__grid imcraft-hero-card__grid--single">
        <a href="https://im-craft.ru" target="_blank" rel="noopener noreferrer">Сайт</a>
      </div>

      <div class="imcraft-hero-card__notice">
        <span>Радиус карты:</span>
        <strong>10 000 блоков</strong>
      </div>
    </aside>

    <button v-else class="imcraft-hero-toggle" type="button" @click="setHeroHidden(false)">
      ImCraft World
    </button>

    <section class="imcraft-login-card" :class="{'is-open': loginOpen}">
      <button class="imcraft-login-card__close" type="button" @click="loginOpen = false" aria-label="Закрыть">×</button>
      <div class="imcraft-login-card__label">Скоро</div>
      <h2>Вход через Minecraft</h2>
      <p>Следующим этапом подключим плагин: сайт покажет код, а игрок подтвердит аккаунт командой в игре.</p>
      <code>/maplink IM-2026</code>
    </section>
  </div>
</template>

<script>
const HERO_STORAGE_KEY = "imcraft.hero.hidden";

export default {
  name: "ImCraftHud",
  data() {
    return {
      appState: this.$bluemap.appState,
      mapViewer: this.$bluemap.mapViewer.data,
      markers: this.$bluemap.mapViewer.markers.data,
      copied: false,
      loginOpen: false,
      heroHidden: this.loadHeroHidden(),
    }
  },
  computed: {
    currentMapName() {
      if (this.mapViewer.map?.name) return this.mapViewer.map.name;
      if (this.mapViewer.map?.id) return this.mapViewer.map.id;
      return "world";
    },
    onlinePlayersText() {
      const players = this.playerCount;
      if (players === 1) return "1 игрок онлайн";
      if (players > 1 && players < 5) return `${players} игрока онлайн`;
      return `${players} игроков онлайн`;
    },
    playerCount() {
      const set = this.findMarkerSet(this.markers, "bm-players");
      return set?.markers?.length || 0;
    }
  },
  methods: {
    loadHeroHidden() {
      try {
        return localStorage.getItem(HERO_STORAGE_KEY) === "true";
      } catch (e) {
        return false;
      }
    },
    setHeroHidden(hidden) {
      this.heroHidden = hidden;
      try {
        localStorage.setItem(HERO_STORAGE_KEY, hidden ? "true" : "false");
      } catch (e) {
        // Ignore storage errors in private/incognito mode.
      }
    },
    findMarkerSet(markerSet, id) {
      if (!markerSet) return null;
      if (markerSet.id === id) return markerSet;
      for (const set of markerSet.markerSets || []) {
        const found = this.findMarkerSet(set, id);
        if (found) return found;
      }
      return null;
    },
    async copyServerIp() {
      try {
        await navigator.clipboard.writeText("mc.im-craft.ru");
        this.copied = true;
        setTimeout(() => this.copied = false, 1800);
      } catch (e) {
        this.loginOpen = true;
      }
    },
    openLoginStub() {
      this.loginOpen = true;
    },
    openMarkers() {
      this.appState.menu.openPage('markers', () => 'Маркеры', {markerSet: this.markers});
    }
  }
}
</script>
